/**
 * How large the judgment's text is set.
 *
 * Its own file, and deliberately not part of lib/reader/layout, because the two are independent.
 * That module decides the reader's GEOMETRY — the measure, the annotation margin, the rail — and
 * every value in it feeds `readerVars`. This feeds nothing there. Changing the reading size
 * changes the size of the text and nothing else: the column keeps its width, the margin keeps
 * its width, and the tier a given screen can carry does not move.
 *
 * Sitting in that file, this invited exactly the opposite reading — that the range was somehow
 * derived from the measure and would have to move with it. It is not, and it does not.
 */

/** The sizes on offer, in px, smallest first. */
export const READING_SIZES = [14, 15, 16] as const

export type ReadingSize = (typeof READING_SIZES)[number]

/** Where the reader starts, before anyone touches the control. */
export const DEFAULT_READING_SIZE: ReadingSize = 15

/**
 * The next size up or down, or null at either end — which is what disables the button.
 *
 * Returned rather than clamped, so the control can tell "there is nowhere further to go" from
 * "here is where you go", and needs to know neither how many steps there are nor what they are.
 */
export function stepReadingSize(size: ReadingSize, direction: 1 | -1): ReadingSize | null {
  const next = READING_SIZES[READING_SIZES.indexOf(size) + direction]
  return next ?? null
}
